<!-- HTML -->
<template>
  <div>

    <section class="hero is-fullheight">
  		<div class="hero-head">
  			<div class="container">
  				<div class="columns is-mobile is-centered">
  					<div class="column is-half-mobile is-one-third-tablet is-one-fourth-desktop">
              <figure class="image logo">
                <img src="../../assets/img/logo/logo-360x120.png" alt="Jugem's Cloud logo">
              </figure>
  					</div>
  				</div>
  			</div>
  		</div>
  		<div class="hero-body">
  			<div class="container has-text-centered">
          <nav class="level is-mobile">
            <div class="level-item has-text-centered">
              <div>
                <figure class="image is-48x48 social">
                  <a href="https://www.facebook.com/JugemsCloudBand" target="_blank">
                    <img src="../../assets/icons/social/facebook.svg" alt="Facebook logo">
                  </a>
                </figure>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <figure class="image is-48x48 social">
                  <a href="https://twitter.com/JugemsCloud" target="_blank">
                    <img src="../../assets/icons/social/twitter.svg" alt="Twitter logo">
                  </a>
                </figure>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <figure class="image is-48x48 social">
                  <a href="https://www.instagram.com/jugems_cloud" target="_blank">
                    <img src="../../assets/icons/social/instagram.svg" alt="Instagram logo">
                  </a>
                </figure>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <figure class="image is-48x48 social">
                  <a href="https://www.youtube.com/c/Jugemscloud" target="_blank">
                    <img src="../../assets/icons/social/youtube.svg" alt="YouTube logo">
                  </a>
                </figure>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <figure class="image is-48x48 social">
                  <a href="https://jugemscloud.bandcamp.com/" target="_blank">
                    <img src="../../assets/icons/social/bandcamp.svg" alt="BandCamp logo">
                  </a>
                </figure>
              </div>
            </div>
          </nav>
  			</div>
  		</div>
  		<div class="hero-foot">
        <div class="columns">
          <div class="column is-one-third has-text-centered">
            Photography by Dave Ludwin and Jugem's Cloud
          </div>
          <div class="column is-one-third has-text-centered">
            <a href="http://jugemscloud.com/" target="_blank">jugemscloud.com</a>
            <br>
            <a href="mailto:jugemscloudband@gmail.com">jugemscloudband<i class="fas fa-at"></i>gmail.com</a>
            <br>
            Copyright {{ year }} Jugem's Cloud
          </div>
          <div class="column is-one-third has-text-centered">
            Website by Mark Lewandowski
            <br>
            Version 4.0
          </div>
        </div>
  		</div>
  	</section>

  </div>
</template>

<!-- JavaScript -->
<script>

export default {

  name: "HomeFooter",

  data() {

    return {

      year: null

    }

  },

  methods: {

    //---------- Year
  	//---------------
    currentYear ( ) {

  		let now = new Date();
      let currentYear = now.getFullYear();

      this.year = currentYear;

    }

  },

  mounted() {

    this.currentYear();

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>

@import "../../assets/scss/variables.scss";

a {
  color: rgba(255,255,255,0.5);
  text-decoration: underline;
}
a:hover {
  color: $white;
}
.social img {
  width: 100%;
  opacity: .5;
}
.social img:hover {
  opacity: 1;
}
.columns {
  margin-bottom: 0;
}
.hero {
  min-height: 102vh !important;
  background: url("../../assets/img/home/bg-silo.jpg") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  font-family: 'astera';
	color: rgba(255,255,255,0.5);
}
.logo {
  padding-top: 25vh;
  opacity: .5;
}
.title {
	letter-spacing: 0.5em;
}

</style>
